import SJButton from '@/components/SJButton'
import SJSpace from '@/components/SJSpace'
import { useLocation, useNavigate } from 'react-router-dom'
import './index.less'

type State = {
  playerId?: string
  type: 'add' | 'edit'
}
const PlayerAgreement = () => {
  document.title = '使用协议'
  const navigate = useNavigate()
  const { state } = useLocation() as { state: State }
  const { type = 'edit', playerId = '' } = state
  const handleNext = () => {
    navigate('/player/face', {
      state: {
        type,
        playerId,
      },
    })
  }
  const handleJump = () => {
    if (type === 'add') {
      navigate('/player/name', {
        state: {
          type,
          playerId,
        },
      })
    } else if (type === 'edit') {
      navigate(-1)
    }
  }
  return (
    <div className="page player-agreement">
      <div className="main">
        <SJSpace height={40} />
        <div className="h1">使用协议</div>
        <div className="section">
          <div className="p">图像信息将经过加密处理，服务系统不会存储人脸照片。</div>
          <div className="p">除机器人识别棋手以外，您的照片不会被用于其他任何用途。</div>
          <div className="p">14岁以下儿童需要在家长监护下完成信息采集。</div>
          <div className="p">
            更多协议内容请查看
            <span
              onClick={() => {
                navigate('/agreement/face')
              }}
            >
              《人脸ID使用协议》
            </span>
          </div>
        </div>
      </div>
      <div className="btn-fixed btn-jump">
        <SJButton type="primary" size="large" onClick={handleNext}>
          同意
        </SJButton>
        <div className="jump" onClick={handleJump}>
          跳过
        </div>
      </div>
    </div>
  )
}

export default PlayerAgreement
